import CheckoutErrorsFactory from '../Errors/factory.js'
import OrderEntity from './OrderEntity.js'
import PurchaseDetailsEntity from './PurchaseDetailsEntity.js'
import PurchaseEntity from './PurchaseEntity.js'

export default class CheckoutEntitiesFactory {
  static orderEntity = ({id, amount, tax, products}) => {
    OrderEntity.validate({
      id,
      amount,
      invalidOrderErrorFactory: CheckoutErrorsFactory.orderCheckoutError
    })
    return new OrderEntity({id, amount, tax, products})
  }

  static purchaseEntity = purchase => new PurchaseEntity(purchase)

  static purchaseDetailsEntity = purchase => new PurchaseDetailsEntity(purchase)
}
